<template>
  <div class="ingress section white-bg">
    <span class="ingress__text" v-html="ingressText"></span>
  </div>
</template>

<script>
export default {
  name: 'ingress',
  props: {
    ingressText: {
      type: String,
      required: true,
    },
  },
};
</script>
